import { Flex, Grid, Typography } from '@aloft/toolkit-sui';

import { Value } from '../MLSDataSheet/types.js';
import { getStringValue } from '../MLSDataSheet/utils/getStringValue.js';

export const PublicRecordValueWithLabel = ({
  value,
  label,
  leftAlign = true,
  options,
}: {
  value?: Value | null;
  label: string;
  leftAlign?: boolean;
  options?: { noCommaInNumber: boolean };
}) => (
  <Grid gridTemplateColumns="1fr 1fr">
    <Typography variant="body1" color="textTertiary">
      {label}
    </Typography>
    <Flex marginLeft={leftAlign ? '10px' : undefined}>
      <Typography variant="body1" __dangerDoNotUseSx={{ textAlign: leftAlign ? 'left' : 'right' }}>
        {getStringValue(value ?? '-', options)}
      </Typography>
    </Flex>
  </Grid>
);
